const routes = [
  {
    path: '/visitor',
    name: 'visitor',
    component: () => import('./pages/Home'),
    // redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'subscribe', // 访客预约记录
        name: 'subscribe',
        component: () => import('./pages/Subscribe'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'invitation', // 访客受邀
        name: 'invitation',
        component: () => import('./pages/Invitation'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      }
    ]
  }
]

export default routes